import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export function numberCountUp(element: Element): void {
  const number = element.querySelector('.number') as HTMLElement
  const numberTo = parseInt(number.getAttribute('data-number-to')) as number

  var counter = { var: 0 }

  gsap.to(counter, {
    var: numberTo,
    duration: 2,
    ease: 'power1.out',
    onUpdate: function () {
      number.innerHTML = Math.ceil(counter.var).toLocaleString()
    },
    scrollTrigger: {
      trigger: element,
      start: 'top bottom'
    }
  })
}
